import React, { useContext, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from 'react-router-dom';

import Layout from '../Layout';

import ErrorPage from '../../pages/ErrorPage';
import Login from '../../pages/Login';
import Inicio from '../../pages/Inicio';
import Cadastro from '../../pages/Cadastro';
import Home from '../../pages/Home';
import AcessarPlataforma from '../../pages/AcessarPlataforma';
import Cookies from 'js-cookie';
import Context, { IContext } from '../../context/Context';
import ValidaEmpresa from '../ValidaEmpresa';
import ConsultarRelatorio from '../../pages/ConsultarRelatorio';
import Relatorio from '../Relatorio';


// Endereço antigo, sem filial: /:cnpj e /:cnpj/login vão para a MATRIZ (mesmo padrão da API)
function RedirecionaMatriz() {
  const { cnpj } = useParams();

  return <Navigate to={`/${cnpj}/MATRIZ/login`} replace />;
}


export default function RouterComponent() {
  const { setDadosUsuario }: IContext = useContext(Context);

  useEffect(() => {
    const usuarioLogado = Cookies.get('dadosUsuario');

    if (usuarioLogado) {
      setDadosUsuario(JSON.parse(usuarioLogado));
    }

  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/acessar' element={<AcessarPlataforma />} />
          <Route path='/erro' element={<ErrorPage />} />
          <Route path='/:cnpj' element={<RedirecionaMatriz />} />
          <Route path='/:cnpj/login' element={<RedirecionaMatriz />} />
          <Route path='/:cnpj/:filial' element={<ValidaEmpresa />}>
            <Route index element={<Login />} />
            <Route path='login' element={<Login />} />
            <Route element={<Layout />}>
              <Route path='inicio' element={<Inicio />} />
              <Route path='cadastro/:entidade' element={<Cadastro />} />
              <Route path='cadastro/:entidade/:codigo' element={<Cadastro />} />
              <Route path='comercial/:entidade' element={<Cadastro />} />
              <Route path='comercial/:entidade/:codigo' element={<Cadastro />} />
              <Route path='consultarRelatorio/:entidade' element={<ConsultarRelatorio />} />
              <Route path='relatorio/:entidade' element={<Relatorio />} />
            </Route>
          </Route>
          <Route path='*' element={<ErrorPage />} />
        </Routes>
      </Router>
    </>
  );
}
